module.exports = {
  LazyImage: {
    true: {
      display: 'none',
      opacity: 0,
    },
    false: {
      display: 'block',
      opacity: 1,
    }
  },
  FullImage: {
    true: {
      display: 'block',
      opacity: 1,
    },
    false: {
      display: 'none',
      opacity: 0,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/LazyImage/shared/styles.js